import React from "react";
import { Button, Popconfirm } from "antd";
import {
  ChangeWebsiteItemGlobalData,
  ChangeWebsitesStateGlobalData,
  GetCurrentStoreData,
  SaveWebsiteBackup,
  WebsitesState,
} from "../../store/websites/types";
import { connect } from "react-redux";
import {
  changeWebsiteItemGlobalData,
  changeWebsitesStateGlobalData,
} from "../../store/websites/actions";
import _ from "lodash";
import {
  getCurrentStoreData,
  saveToLocalBackup,
  saveWebsiteBackup,
} from "../../store/websites/thunks";
import { updateWebsiteAsync } from "../../helpers/async/updateWebsiteAsync";
import { AuthState } from "../../store/auth/types";

interface Props {
  auth: AuthState;
  websites: WebsitesState;
  changeWebsitesStateGlobalData: ChangeWebsitesStateGlobalData;
  getCurrentStoreData: GetCurrentStoreData;
  changeWebsiteItemGlobalData: ChangeWebsiteItemGlobalData;
  saveWebsiteBackup: SaveWebsiteBackup;
  saveToLocalBackup: any;

  onDiscard: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  placement?: string;
}

const UnsavedChangesPopconfirm = (props: Props): JSX.Element => {
  const {
    onDiscard,
    websites,
    changeWebsitesStateGlobalData,
    getCurrentStoreData,
    auth,
    changeWebsiteItemGlobalData,
    saveWebsiteBackup,
    saveToLocalBackup,
    children,
    disabled,
    placement
  } = props;

  const saveChanges = async () => {
    const { currentWebsite } = getCurrentStoreData();
    changeWebsitesStateGlobalData({
      isCustomStylesWaitingForServer: true,
    });
    try {
      saveWebsiteBackup("website");
    } catch (e) {
      console.error(_.get(e, "response.data"));
    }
    const custom_styles = _.get(currentWebsite, "custom_styles", {});
    updateWebsiteAsync({
      accessToken: auth.accessToken,
      subdomain: currentWebsite.subdomain,
      data: { custom_styles },
    })
      .then(() => {
        saveToLocalBackup("website");
      })
      .catch((error) => {
        console.log(error);
        console.log(error.response);
      })
      .finally(() => {
        changeWebsiteItemGlobalData({
          websiteId: currentWebsite.id,
          data: {
            hasUnsavedChanges: false,
          },
        });
        changeWebsitesStateGlobalData({
          isCustomStylesWaitingForServer: false,
        });
        onDiscard();
      });
  };

  return (
    <Popconfirm
      title="You have unsaved theme changes."
      okText="Save"
      cancelText="Discard changes"
      onConfirm={saveChanges}
      onCancel={onDiscard}
      disabled={disabled}
      placement={placement as any || "bottom"}
      overlayStyle={{
        position: "fixed"
      }}
    >
      {children}
    </Popconfirm>
  );
};

const mapStateToProps = (state: any) => ({
  websites: state.websites,
  auth: state.auth,
});
export default connect(mapStateToProps, {
  changeWebsitesStateGlobalData,
  getCurrentStoreData,
  changeWebsiteItemGlobalData,
  saveWebsiteBackup,
  saveToLocalBackup,
})(UnsavedChangesPopconfirm);
